'use es6';

import { pick } from 'underscore';
export const PropertyOptionKeys = {
  CID: 'cid',
  VALUE: 'value',
  LABEL: 'label',
  DISPLAY_ORDER: 'displayOrder',
  HIDDEN: 'hidden'
};
const DefaultPropertyOption = {
  [PropertyOptionKeys.CID]: null,
  [PropertyOptionKeys.VALUE]: '',
  [PropertyOptionKeys.LABEL]: '',
  [PropertyOptionKeys.DISPLAY_ORDER]: -1,
  [PropertyOptionKeys.HIDDEN]: false
};
export default class PropertyOption {
  constructor(data) {
    const formField = pick(data, Object.values(PropertyOptionKeys || {}));
    return Object.assign({}, DefaultPropertyOption, formField);
  }
}